import React from 'react';

import { IconProps, StyledGroup, StyledPath, StyledSvg } from '../iconCommons';

export const IconAlert = ({ color = 'currentColor', size = 'medium', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" size={size} {...props}>
        <StyledGroup stroke={color} strokeWidth="1.5">
            <StyledPath color="none" d="M16 23a.5.5 0 0 1 0-1M16 23a.5.5 0 0 0 0-1" />
            <StyledPath color="none" d="M16 18V7" />
            <StyledPath
                color="none"
                strokeMiterlimit="10"
                d="M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15Z"
            />
        </StyledGroup>
    </StyledSvg>
);
